import { Stack } from "@mantine/core"
import { LabelWithTooltip, MultiSelect } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

export const MultiSelectField = (fields: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {fields.tooltip && (
      <LabelWithTooltip
        label={fields.label}
        hoverHelperText={fields.tooltip}
        justify="space-between"
        fw={600}
        withAsterisk={fields.required ?? false}
      />
    )}
    <MultiSelect
      key={fields.name}
      label={!fields.tooltip ? fields.label : undefined}
      searchable
      classNames={fields.customClass}
      data={
        fields.options?.map((data) => ({
          label: data.label,
          value: data.value.toString(),
        })) || []
      }
      {...form.getInputProps(fields.name)}
      onChange={(value) => {
        form.setFieldValue(fields.name, value)
        form.validateField(fields.name)
      }}
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      error={!form.isValid(fields.name) && form.isTouched()}
    />
  </Stack>
)
